<template>
  <router-view class="page-max-width" />
</template>

<script>
export default {};
</script>
